import React from 'react';

export interface DeleteConfirmationProps {
  objectName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({ objectName, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <p>Are you sure you want to delete {objectName}?</p>
        <div className="form-actions">
          <button className="btn-danger" onClick={onConfirm}>
            Confirm
          </button>
          <button className="btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
